import script from "./ShopProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopProduct.vue?vue&type=script&lang=ts&setup=true"

import "./ShopProduct.vue?vue&type=style&index=0&id=21f3f696&lang=scss&scoped=true"
import "./ShopProduct.vue?vue&type=style&index=1&id=21f3f696&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f3f696"]])

export default __exports__